<template>
  <ul
    class="traveler-type-picker"
    v-if="$store.state.ref && $store.state.ref.travelerTypes"
  >
    <li
      v-for="travelerType in $store.state.ref.travelerTypes"
      :key="travelerType.id"
      @click="onClick(travelerType)"
      :class="{
        selected: value.indexOf(travelerType.id) > -1,
        selectedTour: selectText == 'selectedTour',
        selectedEvent: selectText == 'selectedEvent',
        selectStories: selectText == 'selectStories',
      }"
    >
      {{ travelerType.title }}
    </li>
  </ul>
</template>

<script>
export default {
  data(){
    return{
      checkStories : false,
    };
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    limit: {
      type: Number,
      default: 100,
    },
    selectText: {
      type: String,
      default: "selectedExperience",
    },
  },
  methods: {
    onClick(item) {
      if (!Array.isArray(this.value)) {
        this.value = [];
        this.value.push(item.id);
      } else {
        const index = this.value.indexOf(item.id);
        if (index > -1) {
          this.value.splice(index, 1);
        } else {
          this.value.push(item.id);
        }
      }
      this.$emit("input", this.value);
    },
  },
};
</script>

<style scoped lang="scss">
.traveler-type-picker {
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #fff;
  user-select: none;
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: -10px;

  li {
    margin-top: 10px;
    margin-right: 10px;
    padding: 5px 20px;
    border-radius: 20px;
    border: 1px solid #fff;
    color: #fff;
    cursor: pointer;

    &.selected {
      background-color: #1da1f2;
      border-color: #1da1f2;

      &.selectedTour {
        background-color: #c32aa3;
        border-color: #c32aa3;
      }

      &.selectedEvent {
        background-color: #bd081c;
        border-color: #bd081c;
      }

      &.selectStories {
        background-color: #1877f2;
        border-color: #1877f2;
      }
    }
  }
}
</style>
